import { useSearchParams } from "react-router-dom";
import Seo from "@/components/v2/Seo";
import { Phone, Mail, MapPin, Clock, ShieldCheck } from "lucide-react";
import LeadFormV2 from "@/components/v2/LeadFormV2";
import { Section } from "@/components/v2/blocks";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";

const FAQ = [
  ["L'étude est-elle gratuite ?", "Oui."],
  ["Puis-je transmettre uniquement une facture ?", "Oui."],
  ["Travaillez-vous avec les particuliers ?", "Oui."],
  ["Travaillez-vous avec les professionnels ?", "Oui."],
  ["Mes informations sont-elles confidentielles ?", "Oui. Elles sont utilisées uniquement dans le cadre du traitement de votre demande."],
];

export default function Contact() {
  const [params] = useSearchParams();
  const type = params.get("type") === "facture" ? "facture" : "etude";
  const title = type === "facture" ? "Déposez votre facture" : "Contactez Energy Market";
  const subtitle =
    type === "facture"
      ? "Transmettez votre facture d'électricité ou de gaz : nos équipes l'analysent et reviennent vers vous rapidement."
      : "Vous souhaitez obtenir une étude personnalisée, déposer une facture ou simplement poser une question ? Nous sommes à votre disposition.";

  return (
    <div>
      <Seo title="Contact" description="Demandez une étude gratuite ou déposez votre facture. Energy Market vous répond rapidement, sans engagement." path="/contact" />
      <section className="em-grain border-b border-border">
        <div className="em-container pt-16 md:pt-20 pb-12 max-w-3xl">
          <p className="em-eyebrow mb-4">Contact</p>
          <h1 className="font-display text-4xl md:text-5xl font-black tracking-tight text-primary">{title}</h1>
          <p className="text-lg text-muted-foreground mt-5 leading-relaxed">{subtitle}</p>
        </div>
      </section>

      <div className="em-container py-14 grid lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-7">
          <LeadFormV2 source="contact" requestType={type} />
        </div>

        <aside className="lg:col-span-5 space-y-5">
          <div className="rounded-3xl border border-border bg-card p-6">
            <h3 className="font-display text-lg font-bold text-primary">Coordonnées</h3>
            <ul className="mt-4 space-y-3 text-sm text-muted-foreground">
              <li className="flex items-center gap-3"><Phone className="h-4 w-4 text-primary" /> Téléphone communiqué prochainement</li>
              <li className="flex items-center gap-3"><Mail className="h-4 w-4 text-primary" /> contact@energymarket.fr</li>
              <li className="flex items-center gap-3"><MapPin className="h-4 w-4 text-primary" /> Accompagnement partout en France</li>
              <li className="flex items-center gap-3"><Clock className="h-4 w-4 text-primary" /> Réponse rapide aux demandes</li>
            </ul>
          </div>
          <div className="rounded-3xl bg-primary text-primary-foreground p-6">
            <ShieldCheck className="h-6 w-6 text-accent" />
            <p className="font-display text-lg font-bold mt-3">Étude gratuite &amp; sans engagement</p>
            <p className="text-primary-foreground/80 text-sm mt-2">Vos données sont confidentielles et utilisées uniquement pour traiter votre demande.</p>
          </div>
        </aside>
      </div>

      <Section eyebrow="Questions fréquentes" title="Avant de nous écrire" muted>
        <div className="max-w-3xl">
          <Accordion type="single" collapsible className="w-full">
            {FAQ.map(([q, a], i) => (
              <AccordionItem key={i} value={`q${i}`}>
                <AccordionTrigger>{q}</AccordionTrigger>
                <AccordionContent>{a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </Section>
    </div>
  );
}
